import { CardSvg } from '@/play/cardSvg'

/** Drips: x, length, width, colour, and a bead's distance down (0: none). Heavy where the band is fat. */
const DRIPS: ReadonlyArray<readonly [number, number, number, string, number]> = [
  [52, 96, 6, '#7ee35b', 46],
  [64, 44, 4.5, '#7ee35b', 0],
  [78, 18, 3.5, '#7ee35b', 0],
  [176, 112, 6.5, '#ff5fa2', 58],
  [190, 30, 4, '#ff5fa2', 0],
  [204, 70, 5, '#ff5fa2', 0],
  [262, 14, 3.5, '#3fb8ff', 0],
]

/**
 * Home card art for Drip wall 2: tapered goo strokes on a white wall, fat where they were slow and
 * pointed at their ends; drips cluster under the fat parts, long and short, one carrying a bead,
 * each ending in its bulb. The page's soft sky around the wall.
 */
export function DripWall2CardArt() {
  return (
    <CardSvg bg="#cfd2fa">
      {(id) => (
        <>
          <defs>
            <linearGradient id={id('sky')} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#a9dcf7" />
              <stop offset="0.55" stopColor="#cfd2fa" />
              <stop offset="1" stopColor="#f6d3e8" />
            </linearGradient>
          </defs>
          <rect width="320" height="200" fill={`url(#${id('sky')})`} />
          <rect x="8" y="14" width="304" height="164" fill="#ffffff" />
          <rect x="8" y="178" width="304" height="10" fill="#e3e9f3" />
          {DRIPS.map(([x, len, w, c, bead]) => (
            <g key={x} fill={c}>
              <path d={`M ${x - w * 1.4} 38 C ${x - w * 0.5} 50, ${x - w * 0.35} ${40 + len * 0.6}, ${x - w * 0.3} ${40 + len} L ${x + w * 0.3} ${40 + len} C ${x + w * 0.35} ${40 + len * 0.6}, ${x + w * 0.5} 50, ${x + w * 1.4} 38 Z`} />
              {bead > 0 && <ellipse cx={x} cy={40 + bead} rx={w * 0.75} ry={w * 0.9} />}
              <circle cx={x} cy={43 + len} r={w * 1.05} />
            </g>
          ))}
          {/* Green: slow and fat on the left, thinning to a flicked point. */}
          <path d="M 22 34 C 30 24, 72 22, 92 30 C 112 36, 132 34, 150 31 C 132 38, 112 40, 92 41 C 72 44, 34 46, 22 34 Z" fill="#7ee35b" />
          {/* Pink: tapers in, swells where it was slow, flicks off to the right. */}
          <path d="M 120 36 C 140 30, 168 26, 196 30 C 214 33, 240 30, 262 25 C 242 34, 216 42, 196 42 C 168 44, 140 40, 120 36 Z" fill="#ff5fa2" />
          {/* Blue: fast and thin, barely a drip. */}
          <path d="M 236 44 C 252 38, 276 36, 300 38 C 278 41, 254 46, 236 44 Z" fill="#3fb8ff" />
          <ellipse cx="54" cy="30" rx="16" ry="2.6" fill="#ffffff" opacity="0.55" />
          <ellipse cx="178" cy="31" rx="12" ry="2.2" fill="#ffffff" opacity="0.5" />
        </>
      )}
    </CardSvg>
  )
}
